// extracted by mini-css-extract-plugin
export default {"h6":"style_h6__FmFWJ"};